// extracted by mini-css-extract-plugin
export var copyIcon = "_sp-2";
export var discountCard = "_sp-0";
export var discountCode = "_sp-3";
export var discountContent = "_sp-1";
export var loadingCard = "_sp-4";